import Icon from '../components/Icon.vue'

Icon.register({
  'grin-squint-tears': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M409.6 111.9c-5.6 0.8-10.3-3.9-9.5-9.4 3.3-22.6 12-73.5 26.8-88.3 19.1-19.2 50.7-18.9 70.3 0.7 19.6 19.6 19.9 51 0.7 70.2-14.8 14.8-65.7 23.6-88.3 26.8zM102.4 400.1c5.6-0.8 10.3 3.9 9.5 9.4-3.3 22.6-12 73.5-26.8 88.3-19.2 19.2-50.6 18.9-70.2-0.7-19.6-19.6-19.9-51.1-0.8-70.2 14.8-14.8 65.7-23.6 88.3-26.8zM414.1 143.6c24-3.5 42.1-7.4 56.5-11.5 54.8 94.9 42 218.2-39.2 299.3-81.2 81.1-204.5 94-299.3 39.2 4.1-14.4 8.1-32.5 11.5-56.5 2.9-20.5-12.5-49.6-45.7-45.7-24.1 3.5-42.1 7.4-56.5 11.5-54.8-94.9-41.9-218.2 39.2-299.3 81.2-81.1 204.5-94 299.3-39.2-4.1 14.4-8.1 32.5-11.5 56.5-2.9 20.6 12.7 49.6 45.7 45.7zM255.7 106l-22.5 90.6c-2.2 8.6 5.6 16.7 14.5 14.5l90.5-22.6c13.1-3.3 11.6-22.4-1.8-23.6l-52.3-4.8-4.8-52.3c-1.2-13.3-20.3-15-23.6-1.8zM164.8 336.3c1.3 13.4 20.4 14.9 23.5 1.7l22.6-90.5c2.2-8.7-5.7-16.7-14.5-14.5l-90.5 22.6c-13.1 3.3-11.6 22.4 1.8 23.6l52.3 4.8zM380.5 380.5c42.8-42.9 68-122.3 35.7-167.6-7.1-9.9-21.9-8.5-27.3 2-14.6 28.2-42.4 63.9-76.3 97.8-33.9 33.9-69.5 61.7-97.8 76.3-10.7 5.4-11.8 20.3-2 27.2 14.4 10.2 32.1 14.7 51 14.7 41 0 87.4-21.1 116.7-50.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-squint-tears.js
// module id = 1403
// module chunks = 0